import { SERVER_ERROR_CODES } from '../constants';
import type { ServerErrorCodes } from '../constants/server-error-codes';

export interface ServerErrorField {
  property: ServerErrorCodes | string;
  message: string;
}

export interface ServerErrorFields {
  errors: ServerErrorField[];
}

export interface ServerErrorByProp {
  [key: string]: string | undefined;
}

export type HTTPErrorApiResponse = string | ServerErrorField | ServerErrorFields | null;

function isServerErrorField(error: HTTPErrorApiResponse): error is ServerErrorField {
  return !!error && typeof error === 'object' && !!(error as ServerErrorField).message;
}

function isServerErrorFields(error: HTTPErrorApiResponse): error is ServerErrorFields {
  return !!error && typeof error === 'object' && !!(error as ServerErrorFields).errors;
}

function addFormattedError(error: ServerErrorField, result: ServerErrorByProp) {
  //@todo remove lowerCase after BE fix
  result[error.property.toLowerCase()] = error.message;
}

export function getServerError(errorResponse: HTTPErrorApiResponse): ServerErrorByProp {
  const output: ServerErrorByProp = {};
  if (!errorResponse) {
    return output;
  }

  if (typeof errorResponse === 'string') {
    output[SERVER_ERROR_CODES.common] = errorResponse;
    return output;
  }

  if (isServerErrorFields(errorResponse) && errorResponse.errors.length) {
    errorResponse.errors.forEach((err) => addFormattedError(err, output));
    return output;
  }

  if (isServerErrorField(errorResponse)) {
    addFormattedError(errorResponse, output);
    return output;
  }

  return output;
}
